var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsString, IsOptional, IsBoolean, IsEnum } from "class-validator";
import { DataUpdateType } from "./analytics.dtos";
import { ClearUpgradeUxVariant } from "./features.dtos";
import { GFIDProvider } from "./healthcareorganization.dtos";
export var LoginSource;
(function (LoginSource) {
    LoginSource["CONSENT_LOGIN"] = "Consent Login";
    LoginSource["CONSENT_CLEAR_UPGRADE"] = "Consent Clear Upgrade";
    LoginSource["USER_LOGIN"] = "User Login";
    LoginSource["ACCOUNT_LINKING"] = "Account Linking";
    LoginSource["OTP_VERIFICATION_CONSENT"] = "OTP Verification Consent";
    LoginSource["OTP_VERIFICATION_LOGIN"] = "OTP Verification Login";
})(LoginSource || (LoginSource = {}));
export var EntryFlow;
(function (EntryFlow) {
    EntryFlow["AI"] = "ai";
    EntryFlow["GDU"] = "gdu";
    EntryFlow["IAS"] = "ias";
    EntryFlow["DIRECT"] = "direct";
})(EntryFlow || (EntryFlow = {}));
export class HeapGlobalEventProperties {
}
__decorate([
    IsString(),
    IsOptional()
], HeapGlobalEventProperties.prototype, "projectId", void 0);
__decorate([
    IsString(),
    IsOptional()
], HeapGlobalEventProperties.prototype, "projectType", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], HeapGlobalEventProperties.prototype, "isIAS", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], HeapGlobalEventProperties.prototype, "isDataUpdate", void 0);
__decorate([
    IsEnum(EntryFlow),
    IsOptional()
], HeapGlobalEventProperties.prototype, "entryFlow", void 0);
__decorate([
    IsEnum(DataUpdateType),
    IsOptional()
], HeapGlobalEventProperties.prototype, "dataUpdateType", void 0);
__decorate([
    IsString(),
    IsOptional()
], HeapGlobalEventProperties.prototype, "organizationId", void 0);
__decorate([
    IsEnum(GFIDProvider),
    IsOptional()
], HeapGlobalEventProperties.prototype, "provider", void 0);
__decorate([
    IsEnum(LoginSource),
    IsOptional()
], HeapGlobalEventProperties.prototype, "source", void 0);
__decorate([
    IsEnum(ClearUpgradeUxVariant),
    IsOptional()
], HeapGlobalEventProperties.prototype, "variant", void 0);
